import CallIcon from '@mui/icons-material/Call';
import ChatIcon from '@mui/icons-material/Chat';
import LanguageIcon from '@mui/icons-material/Language';
import MailIcon from '@mui/icons-material/Mail';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { helpText } from '../../../../sic-lib/types/infoData';

interface Props {
    isOpen: boolean;
    onConfirmHandler: () => void;
}

export default function DialogNewRecentDescription({ isOpen, onConfirmHandler }: Props) {
    const { classes } = useStyles();

    const handleCancel = (event: React.MouseEvent<HTMLButtonElement>, reason?: string) => {
        if (!reason || (reason !== 'backdropClick' && reason !== 'escapeKeyDown')) {
            onConfirmHandler();
        }
    };

    const handleConfirm = () => {
        onConfirmHandler();
    };

    const getIcon = () => {
        return (
            <Grid
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="center"
            >
                <Typography component="p" variant="caption" className={classes.iconContainer}>
                    {<CallIcon fontSize="small" color="action" />} &nbsp;Phone
                </Typography>
                <Typography component="p" variant="caption" className={classes.iconContainer}>
                    {<ChatIcon fontSize="small" color="action" />} &nbsp;SMS (Text messages)
                </Typography>
                <Typography component="p" variant="caption" className={classes.iconContainer}>
                    {<MailIcon fontSize="small" color="action" />} &nbsp;Email
                </Typography>
                <Typography component="p" variant="caption" className={classes.iconContainer}>
                    {<LanguageIcon fontSize="small" color="action" />} &nbsp;WebPush
                </Typography>
                <Typography
                    component="p"
                    variant="caption"
                    className={classes.iconContainer}
                    gutterBottom
                >
                    {<LanguageIcon fontSize="small" color="action" />} &nbsp;Web action
                </Typography>
            </Grid>
        );
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleCancel}
            maxWidth="sm"
            aria-labelledby="new_recent_description"
        >
            <DialogTitle id="new_recent_description">New Recent Helper</DialogTitle>
            <DialogContent dividers>
                {/* <Typography
                    className={classes.txtTitle}
                    align="center"
                    component="p"
                    variant="body1"
                    gutterBottom
                >
                    Filter Section
                </Typography>
                <img src="/new_recent_filter.png" alt="filter_description" />
                {helpText['Filter Section'].map(itm => (
                    <Grid>
                        <Typography component="p" variant="subtitle2">
                            {itm.title}
                        </Typography>
                        <Typography component="p" variant="caption" gutterBottom>
                            {itm.paragraph}
                        </Typography>
                    </Grid>
                ))} */}
                <Typography
                    className={classes.txtTitle}
                    align="center"
                    component="p"
                    variant="body1"
                    gutterBottom
                >
                    List Section
                </Typography>
                <Grid display="flex" justifyContent="center">
                    <img src="/contact_card.png" alt="item_description" height={90} />
                </Grid>
                {helpText['List Section'].map((itm, i) => (
                    <Grid key={i}>
                        <Typography component="p" variant="subtitle2">
                            {itm.title}
                        </Typography>
                        <Typography component="p" variant="caption" gutterBottom>
                            {itm.paragraph}
                        </Typography>
                        {itm.title === '6. Last Message Channel Type' && getIcon()}
                    </Grid>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleConfirm} color="secondary" variant="outlined">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    btnCancel: {
        marginRight: theme.spacing(1),
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
    txtTitle: {
        fontWeight: 'bold',
    },
    iconContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
}));
